import { render } from "./disclaimer.vue?vue&type=template&id=09d1e4e5&scoped=true"
import script from "./disclaimer.vue?vue&type=script&lang=js"
export * from "./disclaimer.vue?vue&type=script&lang=js"

import "./disclaimer.vue?vue&type=style&index=0&id=09d1e4e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d1e4e5"]])

export default __exports__